const loadItems = (button) => {
  const container = button.closest('.infinite-scroll__data');
  const totalPages = parseInt(container.querySelector('[data-total-pages]').value);
  let currentPage = parseInt(container.querySelector('[data-current-page]').value);

  currentPage += 1;

  const nextUrl = container.querySelector('[data-next-url]').value.replace(/page=\d+/, `page=${currentPage}`);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  // Show the loading spinner
  const spinner = button.querySelector('.loading-spinner');
  if (spinner) {
    spinner.style.display = 'block';
  }

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      const $html = $(responseHTML);

      // Append new grid items
      const newItems = $html.find('.load-more-grid').html();
      $('.load-more-grid').append(newItems);

      // Replace the load-more container with updated one
      const newScrollData = $html.find('.infinite-scroll__data');
      if (newScrollData.length > 0) {
        $('.infinite-scroll__data').replaceWith(newScrollData);
      } else {
        // If it's not returned, just remove the button manually
        button.remove();
      }
    },
    complete: function () {
      button.removeAttribute("disabled");
      button.classList.remove('loading');

      // Hide the loading spinner
      if (spinner) {
        spinner.style.display = 'none'; 
      }

      // Hide button if last page
      if (currentPage >= totalPages) {
        button.remove();
      }
    }
  });
};

// Use delegation to keep working after DOM updates
document.addEventListener('click', function (e) {
  if (e.target.closest('.js-load-more')) {
    const button = e.target.closest('.js-load-more');
    loadItems(button);
  }
});
